module.exports = __webpack_public_path__ + "img/default-satellite-image.dc14b871.webp";